"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";
import ApiRequest from "@/shared/lib/client-sdk/api-request";
import $ from "jquery";

class AccountUser extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "AccountUser";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/private/account-users"
    );
  }

  getApiPathForCreate() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/accounts/" +
      this.accountId +
      "/users/" +
      this.userId +
      "/invite"
    );
  }

  getApiPathForAccept() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/accounts/" +
      this.accountId +
      "/users/" +
      this.userId +
      "/accept"
    );
  }

  getApiPathForReject() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/accounts/" +
      this.accountId +
      "/users/" +
      this.userId +
      "/reject"
    );
  }
  getApiPathForCancel() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/accounts/" +
      this.accountId +
      "/users/" +
      this.userId +
      "/cancel"
    );
  }

  getApiPathForRefreshUpdateAndDelete() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/users-invitations/" +
      this.id
    );
  }

  getAdminPath() {
    return "/accounts/" + this.accountId;
  }

  getFullName() {
    var firstName = this.userFirstName ? this.userFirstName : "";
    var lastName = this.userLastName ? this.userLastName : "";

    return firstName + " " + lastName;
  }

  getRole() {
    // TECH-12544: a NextLevel account user carries no `role` object at all -- every role it holds,
    // the anchor tier's included, is a role-mapping row, reported as roleUuids/roleLabel/roleVariant.
    // So `role` arrives as null here, and the old `!== undefined` test let null straight through to
    // `this.role.displayName`. Ownership is also read from isAccountOwner directly rather than
    // inferred from "has no role", which was only ever true because legacy owners carry no RoleId --
    // for a NextLevel user that inference labelled every non-owner "Owner".
    if (this.isAccountOwner) return " Owner";
    if (this.role) return " " + this.role.displayName;
    if (this.roleLabel) return " " + this.roleLabel;

    return "";
  }

  updateAccountUserDetails(requestData, callback) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/account-user-details";

    ApiRequest.send("PATCH", requestUrl, requestData).onComplete(
      function (response) {
        if (response.successful) {
          if ($.isFunction(callback)) callback(response.result, null);
        } else {
          if ($.isFunction(callback)) callback(null, response.message);
        }
      }.bind(this)
    );
  }

  setUserAccessAccount(callback) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/users/" +
      this.userId +
      "/set-last-accessed-account/" +
      this.accountId;

    ApiRequest.send("POST", requestUrl).onComplete(
      function (response) {
        if (response.successful) {
          if ($.isFunction(callback)) callback(response.result, null);
        } else {
          if ($.isFunction(callback)) callback(null, response.message);
        }
      }.bind(this)
    );
  }

  getAccountUsers(activeUsersOnly = false, callback) {
    const queryParam = activeUsersOnly ? "?activeUsersOnly=true" : "";

    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/accounts/" +
      this.accountId +
      "/users" +
      queryParam;

    ApiRequest.send("GET", requestUrl).onComplete(
      function (response) {
        if (response.successful) {
          if ($.isFunction(callback)) callback(response.result, null);
        } else {
          if ($.isFunction(callback)) callback(null, response.message);
        }
      }.bind(this)
    );
  }

  getAccountUsersForUser(callback) {
    var requestUrl =
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") +
      "/public/accounts/" +
      this.userUuid +
      "/user";

    ApiRequest.send("GET", requestUrl).onComplete(
      function (response) {
        if (response.successful) {
          if ($.isFunction(callback)) callback(response.result, null);
        } else {
          if ($.isFunction(callback)) callback(null, response.message);
        }
      }.bind(this)
    );
  }
}

export default AccountUser;
